/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleSubmissionResponseModuleVersion } from './moduleSubmissionResponseModuleVersion';
import type { ModuleSubmissionState } from './moduleSubmissionState';
import type { ModuleSubmissionResponseSubmittedAt } from './moduleSubmissionResponseSubmittedAt';
import type { ModuleSubmissionResponseGradedAt } from './moduleSubmissionResponseGradedAt';
import type { ModuleSubmissionResponseGrading } from './moduleSubmissionResponseGrading';
import type { ModuleSubmissionResponseGradingConfigSnapshot } from './moduleSubmissionResponseGradingConfigSnapshot';

/**
 * Module submission with grading information for lecturers
 */
export interface ModuleSubmissionResponse {
  id: string;
  courseId: string;
  moduleId: string;
  moduleVersion: ModuleSubmissionResponseModuleVersion;
  studentId: string;
  studentName: string;
  state: ModuleSubmissionState;
  submittedAt: ModuleSubmissionResponseSubmittedAt;
  gradedAt: ModuleSubmissionResponseGradedAt;
  grading?: ModuleSubmissionResponseGrading;
  gradingConfigSnapshot?: ModuleSubmissionResponseGradingConfigSnapshot;
}
